/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 12:06 PM
 *
 */

import LetteredAvatar from 'react-avatar';
import { Transition } from '@headlessui/react';
import { useAppSelector } from 'stores';

import SidebarIllustration from 'assets/img/sidebar-illustration.svg';

import NavBar from 'components/layout/Sidebar/NavBar/NavBar';

const Sidebar = () => {
  const open = useAppSelector((state) => state.sidebar.open);
  const user = useAppSelector((state) => state.auth.user);

  return (
    <nav
      className={`${
        open ? 'w-[23rem] px-4 py-4 lg:w-1/4 md:w-1/3 sm:w-3/5' : 'w-24 px-4 sm:w-0 sm:p-0 '
      }  fixed z-40 flex h-screen min-h-0 flex-col justify-between space-y-12 bg-white text-3xl shadow-E100 transition-all duration-100 print:hidden `}
    >
      <div className="flex flex-col space-y-8">
        <Transition
          show={open}
          enter="transition-opacity transition-transform duration-200"
          enterFrom="opacity-0 -translate-y-24 "
          enterTo="opacity-100 translate-y-0"
        >
          <div className=" flex w-full items-center space-x-2 rounded-md bg-white p-4 ring-1 ring-gray-400/40">
            {user?.image ? (
              <div className="relative h-16 w-16 overflow-hidden rounded-full bg-white">
                <img src={user?.image} alt="Avatar" className="object-cover" />
              </div>
            ) : (
              user?.name && (
                <LetteredAvatar name={user?.name} size="50" round={true} maxInitials={2} />
              )
            )}

            <div className="flex w-3/4 flex-col">
              <span className="text-xl font-medium text-black line-clamp-1">{user?.name}</span>
              <span className="text-base font-medium tracking-wider text-gray-500 ">
                {user?.role && user?.role.name}
              </span>
            </div>
          </div>
        </Transition>
        <Transition show={!open}>
          <div className="py-4 sm:hidden">
            {user?.image ? (
              <div className="relative h-16 w-16 overflow-hidden rounded-full bg-white">
                <img src={user?.image} alt="Avatar" className="object-cover" />
              </div>
            ) : (
              user?.name && (
                <LetteredAvatar name={user?.name} size="50" round={true} maxInitials={2} />
              )
            )}
          </div>
        </Transition>
        <NavBar />
      </div>
      <Transition
        show={open}
        enter="transition-opacity duration-100 delay-200 "
        enterFrom="opacity-0"
        enterTo="opacity-100"
      >
        <div className="flex w-full flex-col space-y-2">
          <div className="relative h-64 w-full">
            <img src={SidebarIllustration} className="object-cover" alt="Super User Illustration" />
          </div>

          <div>
            <div className="text-center text-sm font-bold text-gray-700">
              &#169; Copyright by Sunya Health Pvt. Ltd.
            </div>
            <div className="text-center text-sm font-medium  text-gray-500">
              System Version: {/* {systemVersion.toUpperCase()}*/}
            </div>
          </div>
        </div>
      </Transition>
    </nav>
  );
};

export default Sidebar;
